// components
import Utm from "../components/_global/utm";

// images
import TopBackground from "../images/seyfeli/seyfeli-header-image.jpg";
import ApparelG from "../images/seyfeli/Apparel.svg";
import Inbox from "../images/seyfeli/Inbox.svg";
import Handshake from "../images/confi/handshake.svg";
import CheckIcon from "../images/icon/check.svg";
import Facts from "../images/confi/location.svg";
import Size from "../images/confi/size.svg";
import Profile from "../images/confi/profile.svg";
import Foursource from "../images/confi/foursource.svg";
import Apparel from "../images/confi/apparel.svg";
import ApparelManufacturer from "../images/confi/apparelManufacturer.svg";
import Banner from "../images/confi/banner.svg";
import Giulio from "../images/yellow-river/eason-wu-yellow-river.jpeg";


export const pageTexts = (t) => {
  return {
    topInfo: {
      title: {
        text: t("seyfeli.topTitle"),
        colorClass: "colorLight",
      },
      subtitle: {
        text: t("seyfeli.subTitle"),
        colorClass: "colorLight",
      },
      bottomDiagonal: true,
      opacity: true,
      image: {
        src: TopBackground,
        alt: t("seyfeli.imgAlt"),
      },
    },
    topIcons: [
      {
        title: {
          text: t("seyfeli.newMarketsValue"),
        },
        subtitle: {
          text: t("seyfeli.newMarketsSubtitle"),
          colorClass: "colorDark text-center",
        },
        icon: {
          src: Handshake,
          alt: t("seyfeli.newMarketsAlt"),
        },
      },
      {
        title: {
          text: t("seyfeli.roiValue"),
        },
        subtitle: {
          text: t("seyfeli.roiSubtitle"),
          colorClass: "colorDark text-center",
        },
        icon: {
          src: ApparelG,
          alt: t("seyfeli.roiAlt"),
        },
      },
      {
        title: {
          text: t("seyfeli.recruitingValue"),
          textAfter: "% reply rate",
          isNum: true,
        },
        subtitle: {
          text: t("seyfeli.recruitingSubtitle"),
          colorClass: "colorDark text-center",
        },
        icon: {
          src: Inbox,
          alt: t("seyfeli.recruitingAlt"),
        },
      },
    ],
    sideIcons1: [
      {
        title: {
          text: t("seyfeli.locationTitle"),
        },
        subtitle: {
          text: t("seyfeli.locationSubtitle"),
          colorClass: "colorDarkLight",
        },
        icon: {
          src: Facts,
          alt: t("seyfeli.locationAlt"),
        },
      },
      {
        title: {
          text: t("seyfeli.productTitle"),
        },
        subtitle: {
          text: t("seyfeli.productSubtitle"),
          colorClass: "colorDarkLight",
        },
        icon: {
          src: Apparel,
          alt: t("seyfeli.productAlt"),
        },
      },
      {
        title: {
          text: t("seyfeli.memberTitle"),
        },
        subtitle: {
          text: t("seyfeli.memberSubtitle"),
          colorClass: "colorDarkLight",
        },
        icon: {
          src: ApparelManufacturer,
          alt: t("seyfeli.memberAlt"),
        },
      },
      {
        title: {
          text: t("seyfeli.membershipTitle"),
        },
        subtitle: {
          text: t("seyfeli.membershipSubtitle"),
          colorClass: "colorDarkLight",
        },
        icon: {
          src: Profile,
          alt: t("seyfeli.membershipAlt"),
        },
      },
      {
        title: {
          text: t("seyfeli.sizeTitle"),
        },
        subtitle: {
          text: t("seyfeli.sizeSubtitle"),
          colorClass: "colorDarkLight",
        },
        icon: {
          src: Size,
          alt: t("seyfeli.sizeAlt"),
        },
      },
      {
        title: {
          text: t("seyfeli.sinceTitle"),
        },
        subtitle: {
          text: t("seyfeli.sinceSubtitle"),
          colorClass: "colorDarkLight",
        },
        icon: {
          src: Foursource,
          alt: t("seyfeli.sinceAlt"),
        },
      },
    ],
    sideIcons2: [
      {
        title: {
          text: t("seyfeli.challengesSquareTitle"),
          textSize: "font24 lineHeight1_3 ",
        },
        subtitle: {
          text: t("seyfeli.challengesSquareSubtitle"),
          colorClass: "colorDark",
          textSize: "font17  pt-10"
        },
        icon: {
          src: '',
          alt: t("seyfeli.newMarketsAlt"),
        },
      },
    ],
    sideIcons3: [
      {
        title: {
          text: t("seyfeli.favoriteToolsTitle"),
          textSize: "font24 lineHeight1_3 ",
        },
        subtitle: {
          text: t("seyfeli.favoriteToolsSubtitle"),
          colorClass: "colorDark",
          textSize: " font17 pt-20"
        },
        icon: {
          src: '',
          alt: t("seyfeli.favoriteToolsAlt"),
        },
        banner: true,
        bannerSrc: Banner,
        bannerAlt: "Banner"
      },
    ],
    giulio: [
      {
        title: {
          text: t("seyfeli.giulioName"),
        },
        subtitle: {
          text: t("seyfeli.giulioTitle"),
          colorClass: "colorDarkLight",
        },
        icon: {
          src: Giulio,
          alt: t("seyfeli.newMarketsAlt"),
        },
      },
    ],
    aboutInfo: {
      title: {
        text: t("seyfeli.aboutTitle"),
        colorClass: "colorDark",
        extraClass: "font40",
      },
      text: {
        text: t("seyfeli.aboutText"),
        colorClass: "colorDark",
        textType: "paragraph",
      },
      separator: true,
    },
    challengesInfo: {
      title: {
        text: t("seyfeli.challengesTitle"),
        colorClass: "colorDark",
        extraClass: "font40",
      },
      text: {
        text: t("seyfeli.challengesText"),
        colorClass: "colorDark",
        textType: "paragraph",
      },
      separator: true,
    },
    findingInfo: {
      title: {
        text: t("seyfeli.findingTitle"),
        colorClass: "colorDark",
        extraClass: "font40",
      },
      text: {
        text: t("seyfeli.findingText"),
        colorClass: "colorDark",
        textType: "paragraph",
      },
      separator: true,
    },
    resultsInfo: {
      title: {
        text: t("seyfeli.resultsTitle"),
        colorClass: "colorDark",
        extraClass: "font40",
      },
      separator: true,
    },
    bullet: {
      icon: { fontAwesome: false, src: CheckIcon, alt: t("homepage.checkAlt") },
      separator: false,
      item: {
        text: [
          t("seyfeli.bullet1"),
          t("seyfeli.bullet2"),
          t("seyfeli.bullet3"),
        ],
        colorClass: "colorDark",
      },
      customPBText: true,
    },
    bottomText: [
      {
        text: t("seyfeli.bulletBottomText"),
        colorClass: "colorDark",
        textType: "paragraph",
      },
    ],
    cta: {
      text: t("seyfeli.cta1"),
      url: "https://foursource.com/apparel-manufacturers/",
      type: "whiteColor",
    },
    cta2: {
      text: t("seyfeli.cta2"),
      url: process.env.GATSBY_CHINA === "true" ? `${process.env.APP_CHINA_URL}/signup/` : Utm(`${process.env.APP_URL}/signup/`),
      type: "mainColor",
    },
    favoriteToolsExtra: t("seyfeli.favoriteToolsExtra"),
    profileText: t("seyfeli.profileText"),
    testimonyName: t("seyfeli.giulioName"),
    testimonyTitle: t("seyfeli.giulioTitle"),
    anchorText: t("seyfeli.anchorText")
  };
};
